export const buildSafePdfFileName = (prefix: string, value: string) => {
  const safeValue = (value || 'document')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 120) || 'document';

  return `${prefix}-${safeValue}`;
};
